angular.module('iqxCore')
.controller('CandidateDepartmentsCtrl', function ($scope, $location, FormSvc, ApplicationSvc, $routeParams) {

  $scope.checkPermissions('CANDIDATE', ["CANDDEPTREG"])

  FormSvc.setOptions($scope,{
    fetchAPI:'callresult/NetCandidateRegistrations',
    fetchWithPersonID:true,
    multiRow:true
    })
  var lang = ApplicationSvc.params.lang

  $scope.buttonCaption = function (dept) {
    if (dept.Details=='Not Registered') {
      return lang.pages.registration.register
    } else {
      return lang.pages.registration.edit
    }
  }

  $scope.buttonClass = function (dept) {
    if (dept.Details=='Not Registered') {
      return 'btn-primary'
    } else {
      return 'btn-info'
    }
  }

  $scope.expandDepartment = function(deptID) {
    $location.url('/canddepartment?departmentid='+deptID)
  }

	$scope.fetch()
  .then(function(){
    if ($routeParams.fromjobsearch) {
      window.close()
    }
  })
})
